import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useRef, useState } from "react";

/**
 * Pita server šta traži — PRE nego što korisnik unese kredencijale.
 *
 * Nije redis-ovo. Plugin koji to ume javlja `inspect: true` u katalogu, forma
 * ga onda pozove i primeni odgovor. MySQL bi ovako mogao da javi da je verzija
 * 8 sa `caching_sha2_password`, Mongo da se nalozi proveravaju u `admin` — ono
 * na čemu smo sami izgubili vreme.
 *
 * Odgovor nosi:
 *   message  šta korisniku reći
 *   hide     polja koja na TOM serveru nemaju smisla (npr. korisničko ime na
 *            Redisu ispod 6.0, gde ACL ne postoji)
 */
export const useInspectSource = () => {
    const [result, setResult] = useState(null);
    const [checking, setChecking] = useState(false);
    const timer = useRef(null);
    const seq = useRef(0);

    const { selected: { selectedServer }, userData, URL } = useContext(GuiContext);

    /**
     * Odloženo, jer se poziva dok korisnik kuca adresu. Svaki novi poziv
     * poništava prethodni — inače sporiji raniji odgovor pregazi noviji.
     */
    const inspect = useCallback((slug, config, delay = 600) => {
        clearTimeout(timer.current);
        if (!slug || !config?.host) {
            setResult(null);
            return;
        }

        timer.current = setTimeout(async () => {
            const mine = ++seq.current;
            setChecking(true);
            try {
                const res = await fetch(`${URL}/api/imports/${slug}/inspect`, {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        server_url: selectedServer || "",
                        guiname: userData?.guiname || "",
                        account_id: userData?.id || "",
                        config: { host: config.host, port: config.port },
                    }),
                });
                const data = await res.json();
                if (mine === seq.current) setResult(data);
            } catch (err) {
                if (mine === seq.current) {
                    setResult({ status: false, message: err.message || "Server nije dostupan" });
                }
            } finally {
                if (mine === seq.current) setChecking(false);
            }
        }, delay);
    }, [URL, selectedServer, userData]);

    const reset = useCallback(() => {
        clearTimeout(timer.current);
        seq.current++;
        setResult(null);
        setChecking(false);
    }, []);

    return { inspect, reset, result, checking, hide: result?.hide || [] };
};
